var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"sl-title"},[_vm._v("Playground")]),_c('GetDelivery')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }